import { createSlice } from '@reduxjs/toolkit';
import {
  getCache,
  setAxiosAuth,
  setCache,
} from '@sahinyazilim/sahinyazilim-components';
import { Payment } from 'account/payment/model/payment';
import { findActivePlan } from 'account/plan/helper/Plan.helper';
import axios from 'axios';
import { AdminCacheNames } from 'common/model/AdminCacheNames';
import { AuthType } from 'common/model/AuthType';
import { Branch } from 'common/model/Branch';
import { NullUndefined } from 'common/model/NullUndefined';
import { mutate } from 'swr';

interface CommonContext {
  restorantCreating?: NullUndefined<boolean>;
  auth?: NullUndefined<AuthType>;
  contacts?: NullUndefined<Contact[]>;
  settings?: NullUndefined<Setting>;
  brand?: NullUndefined<Brand>;
  branches?: NullUndefined<Branch[]>;
  categories?: NullUndefined<Category[]>;
  products?: NullUndefined<Product[]>;
  payments?: NullUndefined<Payment[]>;
  currentPlan?: NullUndefined<Payment>;
}

const auth = getCache(AdminCacheNames.AUTH, null);
setAxiosAuth(auth?.token || null);
const initialState: CommonContext = {
  //Auth
  auth,
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setContacts: (state, { payload }: { payload: Contact[] }) => {
      state.contacts = payload;
    },
    setAuth: (state, { payload }: { payload: NullUndefined<AuthType> }) => {
      state.auth = payload;
      setCache(AdminCacheNames.AUTH, payload);

      setAxiosAuth(payload?.token || null);
      if (payload?.token)
        axios.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${payload?.token}`;

      mutate(() => true, undefined, { revalidate: false });

      if (payload === null) {
        state.contacts = [];
        state.categories = [];
        state.products = [];
        state.settings = null;
        state.brand = null;
        state.restorantCreating = null;
      }
    },
    setRestorantCreating: (
      state,
      { payload }: { payload: boolean | undefined | null },
    ) => {
      state.restorantCreating = payload;
    },
    setCategories: (state, { payload }: { payload: Category[] }) => {
      state.categories = payload;
    },
    setProducts: (state, { payload }: { payload: Product[] }) => {
      state.products = payload;
    },
    setSettings: (state, { payload }: { payload: Setting }) => {
      state.settings = payload;
    },
    setBrand: (state, { payload }: { payload: Brand }) => {
      state.brand = payload;
    },
    setPayments: (
      state,
      { payload }: { payload: NullUndefined<Payment[]> },
    ) => {
      state.payments = payload;
      state.currentPlan = findActivePlan(payload);
    },
    clearAllData: (state) => {
      // Tüm state'i temizle
      state.contacts = [];
      state.categories = [];
      state.products = [];
      state.settings = null;
      state.brand = null;
      state.restorantCreating = null;
      state.auth = null;

      // Cache'leri de temizle
      setCache(AdminCacheNames.AUTH, null);
    },
  },
});

export const commonActions = commonSlice.actions;
export const commonReducer = commonSlice.reducer;
